import React from 'react'

import {FooterLinkButton} from '@vio/atlas/Footer/FooterLinkButton'
import {resolveCapabilities} from '@vio/core/src/brand/capabilities/resolveCapabilities'
import {Brand} from '@vio/core/src/brand/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {openCookiePreferencesCenter} from './utils'

interface Props {
  brand: Brand
}

export const CookiePreferencesLink = ({brand}: Props) => {
  const {compliance} = resolveCapabilities(brand.capabilities, undefined, {
    skipClientOnly: true
  })

  return compliance.cookieConsent.enabled ? (
    <li>
      <FooterLinkButton onClick={openCookiePreferencesCenter}>
        <FormattedMessageWrapper
          dataId="CookiePreferences"
          id="cookiePreferences"
          defaultMessage="Cookie preferences"
        />
      </FooterLinkButton>
    </li>
  ) : null
}
